import _, { escapeRegExp } from 'lodash';
var filterProductByName = function (products, value) {
    var escaped = escapeRegExp(value);
    return value.length < 3 ? [] : _.chain(products).filter(function (d) {
        var reg = new RegExp(escaped, 'i');
        return reg.test(d['name']);
    }).value();
};
export default filterProductByName;
